import React from "react";
import type { Deal } from "@/lib/types/database/deals";
import { CompanyDetailsTab } from "@/components/shared/detail-tabs/CompanyDetailsTab";
import { CompanyContacts } from "@/features/companies/components/CompanyContacts";

export function DealCompanyTab({ item }: { item: Deal }) {
  return (
    <div className="space-y-4 md:space-y-6">
      <CompanyDetailsTab embedded={false} />

      {item.company_id && (
        <div>
          <h3 className="text-base md:text-lg font-semibold mb-3 md:mb-4">Contacts at this Company</h3>
          <CompanyContacts companyId={item.company_id} />
        </div>
      )}
    </div>
  );
}

export function DealContactsTab({ item }: { item: Deal }) {
  if (!item.company_id) {
    return (
      <div className="rounded-lg border p-4 text-sm text-gray-600 dark:text-gray-400">
        This deal is not linked to a company yet, so there are no related contacts to display.
      </div>
    );
  }
  return <CompanyContacts />;
}
